import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { Segnalazione } from '../types/Segnalazione';
import { Stato } from '../types/Stato';
import { Inviante } from '../types/Inviante';
import { CentraleCOT } from '../types/CentraleCOT';
import { Richiesta } from '../types/Richiesta';
import { Operatore } from '../types/Operatore';
import { Richiedente } from '../types/Richiedente';
import { Paziente } from '../types/Paziente';
import { UtenteCollegato } from '../types/UtenteCollegato';
import { SicotService } from '../sicot.service';



@Injectable({
  providedIn: 'root'
})
export class CruscottoRichiestaService {


  API_ENDPOINT_COT_SERVICE = this.sicotService.API_ENDPOINT_COT_SERVICE;

  constructor(private http: HttpClient, private sicotService: SicotService) {  }



  getSegnalazioni() {
    return this.http
      .get<Segnalazione[]>(this.API_ENDPOINT_COT_SERVICE + '/segnalazioni')
      .pipe(
        catchError(() =>
          throwError(() => new Error('Errore nel caricamento dei dati'))
        )
      );
  }

  getStati() {
    return this.http
      .get<Stato[]>(this.API_ENDPOINT_COT_SERVICE + '/stati')
      .pipe(
        catchError(() =>
          throwError(() => new Error('Errore nel caricamento dei dati'))
        )
      );
  }

  getInvianti() {
    return this.http
      .get<Inviante[]>(this.API_ENDPOINT_COT_SERVICE + '/invianti')
      .pipe(
        catchError(() =>
          throwError(() => new Error('Errore nel caricamento dei dati'))
        )
      );
  }

  /** Sistemi informativi (tabella sistema_informativo) per filtro S.I. Inviante, ordine alfabetico. */
  getSistemiInformativi() {
    return this.http
      .get<Inviante[]>(this.API_ENDPOINT_COT_SERVICE + '/sistemi-informativi')
      .pipe(
        catchError(() =>
          throwError(() => new Error('Errore nel caricamento dei sistemi informativi'))
        )
      );
  }

  getCentraliCOT() {
    return this.http
      .get<CentraleCOT[]>(this.API_ENDPOINT_COT_SERVICE + '/centrali')
      .pipe(
        catchError(() =>
          throwError(() => new Error('Errore nel caricamento dei dati'))
        )
      );
  }

  getRichieste(invianti: string[], dataArrivoDa: string | null, dataArrivoA: string | null, segnalazioni: number[], centrali: number[], stato: any, ricerca: any, pageSize: number) {

    let queryParams = new HttpParams();

    if (invianti?.length) {
      invianti.forEach(v => { queryParams = queryParams.append("inviante", v); });
    }
    if (segnalazioni?.length) {
      segnalazioni.forEach(v => { queryParams = queryParams.append("segnalazione", String(v)); });
    }
    if (centrali?.length) {
      centrali.forEach(v => { queryParams = queryParams.append("centrale", String(v)); });
    }

    if (dataArrivoDa) {
      queryParams = queryParams.append("dataArrivoDa", dataArrivoDa);
    }
    if (dataArrivoA) {
      queryParams = queryParams.append("dataArrivoA", dataArrivoA);
    }

    if (stato) {
      queryParams = queryParams.append("stato", stato.toString());
    }

    if (ricerca) {
      queryParams = queryParams.append("ricerca", ricerca.toString());
    }

    queryParams = queryParams.append("pageSize", String(pageSize));

    return this.http
      .get<Richiesta[]>(this.API_ENDPOINT_COT_SERVICE + '/richieste', { params: queryParams })
      .pipe(
        catchError(() =>
          throwError(() => new Error('Errore nel caricamento dei dati'))
        )
      );
  }

  getRichiesteInLavorazione() {

    let queryParams = new HttpParams();
    queryParams = queryParams.append("segnalazione", 1);

    return this.http
      .get<Richiesta[]>(this.API_ENDPOINT_COT_SERVICE + '/richieste', { params: queryParams })
      .pipe(
        catchError(() =>
          throwError(() => new Error('Errore nel caricamento dei dati'))
        )
      );
  }

  getRichiesta(id: number): Observable<Richiesta> {
    return this.http
      .get<Richiesta>(this.API_ENDPOINT_COT_SERVICE + `/richieste/${id}`)
      .pipe(
        catchError(() =>
          throwError(() => new Error('Errore nel caricamento dei dati'))
        )
      );
  }

  getPaziente(id: number) {
    return this.http
      .get<Paziente>(this.API_ENDPOINT_COT_SERVICE + `/pazienti/${id}`)
      .pipe(
        catchError(() =>
          throwError(() => new Error('Errore nel caricamento dei dati'))
        )
      );
  }

  getRichiedente(id: number) {
    return this.http
      .get<Richiedente>(this.API_ENDPOINT_COT_SERVICE + `/richiedenti/${id}`)
      .pipe(
        catchError(() =>
          throwError(() => new Error('Errore nel caricamento dei dati'))
        )
      );
  }

  getOperatore(id: number) {
    return this.http
      .get<Operatore>(this.API_ENDPOINT_COT_SERVICE + `/operatori/${id}`)
      .pipe(
        catchError(() =>
          throwError(() => new Error('Errore nel caricamento dei dati'))
        )
      );
  }

  /** Utenti WSO2 collegati alla richiesta (tabella ponte cot_richiesta_user). */
  getUtentiCollegati(richiestaId: number): Observable<UtenteCollegato[]> {
    return this.http
      .get<UtenteCollegato[]>(this.API_ENDPOINT_COT_SERVICE + `/richieste/${richiestaId}/utenti-collegati`)
      .pipe(
        catchError(() =>
          throwError(() => new Error('Errore nel caricamento degli operatori collegati'))
        )
      );
  }
}